import * as React from "react";
import styled from "styled-components";

interface BreadcrumbsBlockProps {
  breadcrumbsElement: BreadcrumbsElementData
}

const BreadcrumbsBlock = (props: BreadcrumbsBlockProps) => {
  const {breadcrumbsElement} = props;
  const {elementName,elementDescription} = breadcrumbsElement;
  return (
    <div className="materialize-theme-styles">
      <BreadcrumbsPositionFixer/>
      <BreadcrumbsContainer className="page-title page-title-center ptb-50">
        <div className="container">
          <BreadcrumbsTitle className="text-bold white-text font-40">{elementName}</BreadcrumbsTitle>
          <BreadcrumbDescription className="breadcrumb">{elementDescription}</BreadcrumbDescription>
        </div>
      </BreadcrumbsContainer>
    </div>
  )
};

/** STYLES */

// H1 STRONY => WYGLĄD JAK DOTYCHCZASOWY H2 (MATERIALIZE: H2 LINE-HEIGHT 3.916REM)
const BreadcrumbsTitle = styled.h1`
  line-height: 3.916rem;
  margin: 0;
`;

const BreadcrumbsPositionFixer = styled.div`
  background: #03a9f4;
`;

const BreadcrumbsContainer = styled.section`
  background: #03a9f4 !important;
`;

const BreadcrumbDescription = styled.p`
  color: white;
  font-weight: bold;
  font-size: 13px;
 
`;

export default BreadcrumbsBlock


// WEBPACK FOOTER //
// ./src/layouts/breadcrumbs-block/breadcrumbs-block.tsx